var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "p",
        {
          staticStyle: {
            "font-size": "16px",
            color: "rgba(0, 0, 0, 0.85)",
            "font-weight": "800",
            "margin-bottom": "20px",
            "margin-top": "30px"
          }
        },
        [
          _c("span", { staticStyle: { "font-size": "20px" } }, [
            _vm._v(_vm._s(_vm.language["system.loginPhoneVerify"]))
          ])
        ]
      ),
      _c(
        "a-form-model",
        { ref: "form", attrs: { model: _vm.model, rules: _vm.validatorRules } },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "15px" } }, [
              _vm._v(_vm._s(_vm.model.title))
            ])
          ]),
          _c(
            "a-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "a-col",
                { staticClass: "gutter-row", attrs: { span: 16 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { required: "", prop: "phoneCaptcha" } },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            size: "large",
                            type: "text",
                            placeholder: _vm.language["system.verificationCode"]
                          },
                          model: {
                            value: _vm.model.phoneCaptcha,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "phoneCaptcha", $$v)
                            },
                            expression: "model.phoneCaptcha"
                          }
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "mail" },
                            slot: "prefix"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { staticClass: "gutter-row", attrs: { span: 8 } },
                [
                  _c("a-button", {
                    staticClass: "getCaptcha",
                    attrs: {
                      tabindex: "-1",
                      disabled: _vm.state.smsSendBtn,
                      title:
                        (!_vm.state.smsSendBtn &&
                          _vm.language["portal.front.getCode"]) ||
                        _vm.state.time + " s"
                    },
                    domProps: {
                      textContent: _vm._s(
                        (!_vm.state.smsSendBtn &&
                          _vm.language["portal.front.getCode"]) ||
                          _vm.state.time + " s"
                      )
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.getCaptcha2fa($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }